import { useMemo } from "react";
import { useSelector } from "react-redux";
import { rulesForTPatientSurgery, procedureIpsIdToGroup } from "../data";

const defaultVisibility = {
  showProcedureTab: false,
  showAssessmentTab: false,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: false,
  showDefineSessionsOriginModal: false,
  tabIndex: 1,
};

export const useTPatientSurgeryVisibility = () => {
  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const { scheduleEvents } = useSelector(
    (state) => state.patient.scheduleEvent
  );

  const { state, track, numberEvents, eventsDefinedBy, procedure, patient } =
    patientSurgery.data ?? {};

  const { id: ipsId } = patient.user.ips ?? {};
  const { id: procedureParentId } = procedure.procedure ?? {};

  return useMemo(() => {
    const groupKey = procedureIpsIdToGroup[`${procedureParentId}-${ipsId}`];
    if (!groupKey) return defaultVisibility;

    const baseRules = rulesForTPatientSurgery[groupKey];
    if (!baseRules) return defaultVisibility;

    const trackRules = baseRules[track];
    if (!trackRules) return defaultVisibility;

    const rule = trackRules[state];
    if (!rule) return defaultVisibility;

    return typeof rule === "function"
      ? rule({ scheduleEvents, numberEvents, eventsDefinedBy })
      : rule;
  }, [
    procedureParentId,
    ipsId,
    track,
    state,
    scheduleEvents,
    numberEvents,
    eventsDefinedBy,
  ]);
};
